export default __webpack_public_path__ + "static/media/icons-outline-start-tour.14f1c2d3.svg";